module.exports = __webpack_public_path__ + "img/user_DongQiang.a6238b86.png";